import { ResponseDTO, ResponseError } from '@cco/model';
import { TenantBaseService } from '@app/shared/services/tenant-base.service';

export abstract class ResponseDtoService extends TenantBaseService {
  protected constructor(protected baseUrl: string) {
    super(baseUrl);
  }

  protected handleResponse<R, K>(response: ResponseDTO<R>, handlerFn?: (result: R) => K): K {
    // Assume success when the response is null
    if (response == null) {
      return;
    }

    if (response.status === ResponseDTO.STATUS_SUCCESS) {
      if (handlerFn) {
        return handlerFn(response.result);
      } else {
        return;
      }
    } else if (response.status === ResponseDTO.STATUS_ERROR) {
      throw new ResponseError(response.message);
    } else {
      throw new ResponseError('Invalid response status from server.');
    }
  }

  protected mapIdentity<T>(o: T): T {
    return o;
  }
}
